import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { eyeqLogo, zeusLogo } from 'src/component/util/image';
import styles from 'src/screen/login-screen/login-screen.module.scss';

export const LoginBannerWincanton = (): React.ReactElement => {
	return (
		<Container className={`ms-0 me-0 pt-5 ${styles.imgBackWincanton}`}>
			<Row className="px-lg-1 pt-5 pb-3">
				<Col lg={2}></Col>
				<Col
					lg={10}
					className="p-0"
				>
					<h1>
						<img src={eyeqLogo} />
					</h1>
				</Col>
				<Col lg={1}></Col>
			</Row>
			<Row className="px-lg-1 py-3">
				<Col lg={2}></Col>
				<Col
					lg={10}
					className="p-0"
				>
					<h1 className="wincanton-color-primary pb-3">
						<b className="font-44">Hauliers</b>
					</h1>
					<p className="wincanton-color-primary fs-4">
						<h3 className="font-16">
							<b className="font-16">
								Gain instant, free access to domestic
								<br /> UK loads and contract lanes; <br />
							</b>
							negotiate and accept jobs, have <br />
							complete visibility of all loads and <br />
							manage admin more easily with proof of <br />
							delivery uploads. <br />
						</h3>
					</p>
				</Col>
				<Col lg={1}></Col>
			</Row>
			<Row className="px-lg-1 py-3">
				<Col lg={2}></Col>
				<Col
					lg={10}
					className="p-0"
				>
					<p className="wincanton-color-primary fs-4">
						<p className="font-16">
							Use our EyeQ Driver mobile
							<br />
							app to help keep you and your
							<br />
							business moving.
						</p>
					</p>
				</Col>
				<Col lg={1}></Col>
			</Row>
		</Container>
	);
};
